import React from 'react'
import Navbar from '../components/Navbar'
import ContactHero from '../components/ContactHero'
import Footer from '../components/Footer'
import { useLocation } from 'react-router-dom'
function Contact() {

  React.useEffect(() => {
    document.title = "Contact Us";
  }, []);

  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // use "smooth" if you want animation
    });
  }, [pathname]);

  return (
    <>
      <Navbar />
      <ContactHero />
      <Footer />
    </>
  )
}

export default Contact